import React, {Suspense} from "react";
import { useLocation } from "react-router-dom";
import { postGuid } from "../../data/API_Base"

// Header
import SvegileNavbar from "../Components/Navbar/SvegileNavbar.js";
import { MegaMenuWithHover } from "../Components/Navbar/navbar.js"
import svegileNavbar from "../Texts/navbar/svegileNavbar.js";

// texts for sections as props
import homeVideo from "../Texts/homeVideo.js";
import focus from "../Texts/focus.js";
import contactFooter from "../Texts/contactUsFooter.js";
import footerLarge from "../Texts/footerLarge.js";

// sections
import Engagement from "../Sections/Engagement.js";
import Technology from "../Sections/Technology.js";

// components
import AboutUsHeader from "../Components/Headers/AboutUsHeader.js";
import CardBlogFullBg from "../Components/Cards/CardAboutUs.js";
import HeadingBadge from "../Components/Heading/HeadingBadge.js";

// texts for sections as props
import engagement from "../Texts/engagement.js";
import technology_frontend from "../Texts/technologies/technology_frontend.js";
import technology_backend from "../Texts/technologies/technology_backend.js";
import technology_mobile from "../Texts/technologies/technology_mobile.js";
import technology_cloud from "../Texts/technologies/technology_cloud.js";

import headerPostDark from "../Texts/headers/headerPostDark.js";

import softwareCycle from "assets/img/svegile/softwareCycle.png";

// texts for sections as props
import services from "../Texts/services.js";
import ourValues from "../Texts/ourValues.js";
import testimonials from "../Texts/testimonials.js";

// Dynamic imports for sections
const Services = React.lazy(() => import("../Sections/Services.js"));
const Focus = React.lazy(() => import("../Sections/Focus.js"));
const OurValues = React.lazy(() => import("../Sections/OurValues.js"));
const Testimonials = React.lazy(() => import("../Sections/Testimonials.js"));
const ContactFooter = React.lazy(() => import( "../Sections/ContactFooter.js"));
const FooterLarge = React.lazy(() => import( "../Sections/FooterLarge.js"));
const HomeVideo = React.lazy(() => import( "../Sections/HomeVideo.js"));

const LoadingSpinner = React.lazy(() => import( '../Views/LoadingSpinner.js'));

const discoverImage = {
  id: "Engagement",
  image: softwareCycle,
  size: "lg",
  rounded: false,
};
const technologyHeader = {
  title: "Technologies",
  alignment: "center",
};

export default function Home() {
  debugger;
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Svegile Technologies - Home"
    postGuid();
  }, [location]);
  return (
    <div>
      
      <SvegileNavbar {...svegileNavbar} />
      <main>
      {/* <MegaMenuWithHover/> */}
        <HomeVideo {...homeVideo} />
        <div className="mx-auto lg:px-1">
          <Suspense fallback={<LoadingSpinner/>}>
            <Services {...services} />
            <Focus {...focus} />
          </Suspense>
        </div>
        <div className="mx-auto lg:px-1">
          <Suspense fallback={<LoadingSpinner/>}>
            <OurValues {...ourValues} />
            <Testimonials {...testimonials} />
          </Suspense>
        </div>
        <AboutUsHeader {...headerPostDark} />
        <div className="mx-auto px-4 pt-10 pb-10">
          <CardBlogFullBg {...discoverImage} />
          </div>
          <div className="mx-auto px-4 pt-10">
          <Engagement {...engagement} />
        </div>
        <div className="mx-auto px-4 pt-6">
          <HeadingBadge {...technologyHeader} />
        </div>
        <div className="mx-auto px-4 pb-6" id="Technology">
          <Technology {...technology_frontend} />
          <Technology {...technology_backend} />
          <Technology {...technology_mobile} />
          <Technology {...technology_cloud} />
        </div>
        <ContactFooter {...contactFooter} />
      </main>
      <div className="-mt-20">
        <FooterLarge {...footerLarge} />
      </div>
    </div>
  );
}
